import { nextTick, reactive, watch } from 'vue';
import BasePagedListSetupService from '@/setup/BasePagedListSetupService';
import anime from 'animejs';
import useUnlockModuleOrderListFilterService from '@/services/unlock-module/order/UnlockModuleOrderListFilterService';
import { useConfirm, useNotif } from '@orion.ui/orion';
import { PLUGIN_TYPE } from '@/typings/enums/PLUGIN_TYPE';
import { PLUGIN_EVENT_TYPE } from '@/typings/enums/PLUGIN_EVENT_TYPE';
import PluginApiAgency from '@/api/PluginApiAgency';

type Props = SetupProps<typeof UnlockModuleOrderListSetupService.props>

export default class UnlockModuleOrderListSetupService extends BasePagedListSetupService<Props, ICompanyWithOrderPluginModel> {
	static readonly props = undefined;

	protected listBind: Partial<PagedList<ICompanyWithOrderPluginModel>> = {
		// layout: 'grid',
		// cellClass: 'cell',
		itemAdjective: 'sélectionée',
		itemType: 'agence',
		// gridClass: 'arm-grid arm-grid--aside-md',
	};

	filterService = useUnlockModuleOrderListFilterService();

	sortByOptions = [
		{
			label: 'Raison sociale',
			value: 'Name',
		},
		{
			label: 'Date de création',
			value: 'Id',
		},
	];

	readonly _aside?: OrionAside;

	private readonly setupState = reactive({
		selectedAgencyIds: [] as number[],
		selectAllAgencies: false,
		dataLoaded: false,
	});

	get selectAllAgencies () { return this.setupState.selectAllAgencies; }

	get filter () { return this.filterService.filter;}
	get listTitle () {return 'Demandez le déblocage du module de Commandes';}

	get canSelectAll () {
		return this.list.filter(x => !x.plugins[0].isActive && !x.plugins[0].events.length).length;
	}

	constructor (props?: Props, _aside?: OrionAside) {
		super(props, _aside);
		this._aside = _aside;

		watch(() => this.filter.showIsActivated, async () => {
			this.setupState.selectedAgencyIds.empty();
			await this.refreshListAsync();
			this.animList();
		});

		watch(() => this.listState.total, async () => {
			nextTick(() => {
				this.animList();
			});
		});
	}

	selectAllListItems () {
		this.listState.selected.empty().push(...this.listState.list.filter(x => !x.plugins[0].isActive && !x.plugins[0].events.length));
	}

	animList () {
		anime({
			targets: '.orion-list__cell > div',
			translateY: ['70px', 0],
			opacity: [0, 1],
			duration: 300,
			delay: anime.stagger(100),
			easing: 'easeOutQuad',
		});
	}

	async unlockAsync (payload?: ICompanyWithOrderPluginModel, single = false) {
		if (await useConfirm(single && payload
			? `Confirmez-vous la demande de déblocage pour l'agence ${payload.name} ?`
			: `Confirmez-vous la demande de déblocage du module de commandes pour ces agences ?`)) {
			try {
				this._aside?._loader()?.show(`Envoi de votre demande...`);
				await PluginApiAgency.request({
					type: PLUGIN_TYPE.Order,
					message: 'Merci de débloquer le module de commandes pour ces agences',
					agencyCompanyIds: single && payload ? [ payload.id ] : this.listSelectedItems.mapKey('id'),
				});
				useNotif.success(`Et voilà !`, `La demande de déblocage du module a bien été envoyée !`);
				single && payload
					? this.list?.find(x => x.id === payload.id)?.plugins[0].events.push({
						date: new Date().toPost(),
						type: PLUGIN_EVENT_TYPE.Requested,
					})
					: this._aside?.close();
			} catch (err: any) {
				useNotif.danger(`Oops !`, err?.response?.data);
			} finally {
				this._aside?._loader()?.hide();
			}
		}
	}
}
